import { Global } from '@emotion/react';

type Props = {
  orientation: 'portrait' | 'landscape';
};

export const ConfigurePrintOrientation = ({ orientation }: Props) => {
  const size = orientation === 'landscape' ? 'A4 landscape' : 'auto';

  return (
    <Global
      styles={{
        'body, html': {
          '@media print': {
            '@page': {
              size,
            },
          },
        },
      }}
    />
  );
};
